export default "__VITE_ASSET__b633fe3a__"